import elementForm from "@/package/elementForm/elementForm";
elementForm.install = Vue => Vue.component(elementForm.name, elementForm);      //表单组件
export default elementForm
